const TOKEN_KEY = 'token'
const REMEMBER_KEY = 'k365-remember'

export const getToken = () => (
    window.localStorage.getItem(TOKEN_KEY) || window.sessionStorage.getItem(TOKEN_KEY)
)

export const shouldRemember = () => window.localStorage.getItem(REMEMBER_KEY) !== '0'

export const setToken = (token: string, remember = true) => {
    clearToken()
    const store = remember ? window.localStorage : window.sessionStorage
    store.setItem(TOKEN_KEY, token)
    window.localStorage.setItem(REMEMBER_KEY, remember ? '1' : '0')
}

export const clearToken = () => {
    window.localStorage.removeItem(TOKEN_KEY)
    window.sessionStorage.removeItem(TOKEN_KEY)
}

export const isTokenExpired = (token: string | null) => {
    if (!token) return true
    try {
        const payload = JSON.parse(atob(token.split('.')[1]))
        if (!payload?.exp) return true
        return Math.floor(Date.now() / 1000) >= payload.exp
    } catch (error) {
        return true
    }
}
